import React from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import Typography from "@material-ui/core/Typography";
import { Route, Switch, Redirect } from 'react-router-dom';
import Spin from 'components/common/Spin';
import { GET_PROFILE } from 'graphql/hc/profile';
import Tabs from './Tabs';
import GeneralInfo from 'modules/hc/profile/profileForms/General';
import CalendarView from "../calendar-view";
import NotificationsSettings from 'components/settings/Notifications';
import HCStudents from 'modules/hc/studentsList/index';

const HCProfile = ({
  match: {
    params: { id },
  },
}) => {
  return (
    <Query query={GET_PROFILE} variables={{ id }} fetchPolicy={"cache-and-network"}>
      {({ data, loading, error }) => {
        if (loading) return <Spin spinning />;
        if (error) return 'Error';
        const profile = data.hc_profile[0];
        if (!profile) return 'No profile found';
        const { user } = profile;
        return (
          <div>
            <Helmet title={`Profile`} />
            <Typography variant="h4" style={{ marginBottom: 24 }}>Profile</Typography>
            <Tabs userId={id} />
            <Switch>
              <Route
                path={`/hcs/${id}/profile/general`}
                render={() => <GeneralInfo user={user} profile={profile} />}
              />
              <Route
                path={`/:role/:id/profile/calendar`}
                component={CalendarView}
              />
              <Route
                path={`/:role/:id/profile/settings`}
                render={() => <NotificationsSettings user={user} profile={profile} />}
              />
              <Route
                path={`/:role/:id/profile/students`}
                render={(props) => <HCStudents {...props} userId={id} />}
              />
              <Redirect
                path={`/hcs/${id}/profile`}
                to={`/hcs/${id}/profile/general`}
              />
            </Switch>
          </div>
        );
      }}
    </Query>
  );
};

export default HCProfile;
